module.exports = {"140723100":"义兴镇","140723101":"李阳镇","140723102":"松烟镇","140723103":"青城镇","140723104":"横岭镇","140723200":"喂马乡","140723201":"平松乡","140723203":"马坊乡","140723400":"城区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140723.json
// module id = 413
// module chunks = 0